import mobile from "is-mobile";

import useUiStore from "@app/analytics/stores/useUiStore";
import useWindowDimensions from "@app/common/hooks/useWindowDimensions";
import theme from "@app/common/theme";

interface UseResponsiveView {
  /** True if user is using a mobile browser _or_ on a very narrow screen */
  isMobile: boolean;
  /** True if inMobile is true and the user has not explicitly requested the desktop view */
  inMobileView: boolean;
  /** True if the user is in a desktop browser/wide screen, or has specifically requested the desktop view */
  inDesktopView: boolean;
}

const useResponsiveView = (): UseResponsiveView => {
  const { windowWidth } = useWindowDimensions();

  const forceDesktopView = useUiStore((state) => state.forceDesktopView);
  const isMobile = windowWidth <= theme.breakpoints.values.mobile || mobile();

  return {
    isMobile,
    inMobileView: !forceDesktopView && isMobile,
    inDesktopView: forceDesktopView || !isMobile,
  };
};

export default useResponsiveView;
